module.exports = __webpack_public_path__ + "static/iso-14001-3ad319839487a492aa638c1038128282.png";